/* Daily Goods CRO V1.2 — lightweight product + cart enhancements, no dependencies */
(function(){
  function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}

  ready(function(){
    /* Product page: sticky mobile Add to Cart */
    if(document.body.classList.contains('template-product')){
      var mainBtn=document.querySelector('[data-add-to-cart]');
      var form=mainBtn && mainBtn.closest('form');
      if(mainBtn && form){
        var title=document.querySelector('.product-single__title');
        var price=document.querySelector('[data-product-price]');
        var bar=document.createElement('div');
        bar.className='dg-mobile-atc';
        bar.setAttribute('aria-hidden','true');
        bar.innerHTML='<div class="dg-mobile-atc__meta"><div class="dg-mobile-atc__title"></div><div class="dg-mobile-atc__price"></div></div><button type="button" class="dg-mobile-atc__button">Add to cart</button>';
        document.body.appendChild(bar);
        var stickyBtn=bar.querySelector('.dg-mobile-atc__button');
        var stickyTitle=bar.querySelector('.dg-mobile-atc__title');
        var stickyPrice=bar.querySelector('.dg-mobile-atc__price');
        stickyTitle.textContent=title ? title.textContent.trim() : 'Selected item';

        function sync(){
          if(price) stickyPrice.textContent=price.textContent.trim();
          stickyBtn.disabled=!!mainBtn.disabled;
          var txt=mainBtn.querySelector('[data-add-to-cart-text]');
          stickyBtn.textContent=txt ? txt.textContent.trim() : 'Add to cart';
        }
        sync();
        new MutationObserver(sync).observe(mainBtn,{attributes:true,subtree:true,childList:true,characterData:true});
        if(price) new MutationObserver(sync).observe(price,{subtree:true,childList:true,characterData:true});

        stickyBtn.addEventListener('click',function(){if(!mainBtn.disabled)mainBtn.click();});

        function setVisible(show){
          if(window.innerWidth>768) show=false;
          bar.classList.toggle('is-visible',show);
          document.body.classList.toggle('dg-sticky-atc-active',show);
          bar.setAttribute('aria-hidden',show?'false':'true');
        }

        if('IntersectionObserver' in window){
          var io=new IntersectionObserver(function(entries){
            var visible=entries[0] && entries[0].isIntersecting;
            setVisible(!visible && window.scrollY>250);
          },{threshold:.05});
          io.observe(mainBtn);
        }else{
          window.addEventListener('scroll',function(){
            var r=mainBtn.getBoundingClientRect();
            setVisible(r.bottom<0 && window.scrollY>250);
          },{passive:true});
        }
        window.addEventListener('resize',function(){if(window.innerWidth>768)setVisible(false);},{passive:true});
      }
    }

    /* Cart page: quick add for single-variant Complete Your Look products */
    var look=document.querySelector('[data-dg-complete-look]');
    if(look){
      var addUrl=look.getAttribute('data-cart-add-url') || '/cart/add.js';
      look.addEventListener('click',function(e){
        var btn=e.target.closest('[data-dg-look-add]');
        if(!btn) return;
        e.preventDefault();
        if(btn.disabled) return;
        var variantId=btn.getAttribute('data-variant-id');
        if(!variantId) return;
        var original=btn.textContent;
        btn.disabled=true;
        btn.classList.add('is-loading');
        btn.textContent='Adding…';
        fetch(addUrl,{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:Number(variantId),quantity:1}]})
        }).then(function(res){
          if(!res.ok) throw new Error('Add to cart failed');
          return res.json();
        }).then(function(){
          btn.textContent='Added';
          window.location.reload();
        }).catch(function(){
          btn.disabled=false;
          btn.classList.remove('is-loading');
          btn.textContent=original;
          window.location.href='/cart';
        });
      });
    }
  });
})();
